import React from "react";
import Modal from "react-bootstrap/Modal";
import "./QuizPreviewModal.scss";

const QuizPreviewModal = ({ show, onHide, data }) => {
  if (!data) return null;

   const mcqList = data.assignment_data?.mcq;
  const fibList = data.assignment_data?.fill_in_the_blank;
  const shortList = data.assignment_data?.short_answer;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="quiz-preview-modal" scrollable>
      <Modal.Header closeButton className="border-0 pb-2">
        <div>
           <h5 className="fw-bold m-0 text-dark">Assessment Preview</h5>
           <p className="text-muted fz12 mb-0">Reviewing generated paper structure</p>
        </div>
      </Modal.Header>
      
      <Modal.Body className="p-0 bg-light">
        
        {/* TOP BAR: Summary of Selection */}
        <div className="summary-strip">
           <div className="strip-item">
              <span className="lbl">Subject:</span>
              <span className="val">{data.subject}</span>
           </div>
           <div className="strip-item">
              <span className="lbl">Topic:</span>
              <span className="val">{data.chapter}</span>
           </div>
           <div className="strip-item">
              <span className="lbl">Total Qs:</span>
              <span className="val fw-bold text-primary">
                {/* {(data?.mcq?.length || 0) + (data?.fill_in_the_blank?.length || 0) + (data?.short_answer?.length || 0) + (data.questions?.long || 0)} */}
                {data?.total_questions || 0}
              </span>
           </div>
           <div className="strip-item ms-auto">
              <span className="badge bg-warning text-dark">Draft Mode</span>
           </div>
        </div>

        {/* MAIN QUESTION LIST CONTAINER */}
        <div className="paper-container p-4">
          
          {/* 1. MCQ SECTION */}
          {mcqList?.length > 0 && (
            <div className="question-section mb-4">
              <div className="section-header">
                <h6 className="section-title">Section A: Multiple Choice Questions</h6>
                <span className="marks-info">(1 Mark each)</span>
              </div>
              
              {mcqList?.map((q) => (
                <div key={q.id} className="question-card">
                  <div className="q-head">
                    {/* <span className="q-num">Q{questionCounter++}.</span> */}
                    <p className="q-text">{q.question}</p>
                  </div>
                  <div className="options-grid">
                    {q.options.map((opt, idx) => (
                      <div key={idx} className="option-pill">
                        <span className="opt-letter">{String.fromCharCode(65 + idx)}</span>
                        {opt}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* 2. FIB SECTION */}
          {fibList?.length > 0 && (
            <div className="question-section mb-4">
              <div className="section-header">
                <h6 className="section-title">Section B: Fill in the Blanks</h6>
                <span className="marks-info">(1 Mark each)</span>
              </div>
              
              {fibList.map((q) => (
                <div key={q.id} className="question-card">
                  <div className="q-head">
                    {/* <span className="q-num">Q{questionCounter++}.</span> */}
                    <p className="q-text">{q.question}</p>
                  </div>
                  <div className="answer-placeholder">
                    <span>Answer: __________________________</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* 3. SHORT Q SECTION */}
          {shortList?.length > 0 && (
            <div className="question-section mb-4">
              <div className="section-header">
                <h6 className="section-title">Section C: Short Answer Questions</h6>
                <span className="marks-info">(2 Marks each)</span>
              </div>
              
              {shortList.map((q) => (
                <div key={q.id} className="question-card">
                   <div className="q-head">
                    {/* <span className="q-num">Q{questionCounter++}.</span> */}
                    <p className="q-text">{q.question}</p>
                  </div>
                  <div className="writing-space short">
                    <div className="line"></div>
                    <div className="line"></div>
                  </div>
                </div>
              ))}
            </div>
          )}

           {/* 4. LONG Q SECTION */}
           {/* {longList.length > 0 && (
            <div className="question-section mb-4">
              <div className="section-header">
                <h6 className="section-title">Section D: Long Answer Questions</h6>
                <span className="marks-info">(5 Marks each)</span>
              </div>
              
              {longList.map((q) => (
                <div key={q.id} className="question-card">
                   <div className="q-head">
                    <span className="q-num">Q{questionCounter++}.</span>
                    <p className="q-text">{q.question}</p>
                  </div>
                  <div className="writing-space long">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                  </div>
                </div>
              ))}
            </div>
          )} */}

          {/* {questionCounter === 1 && (
             <div className="text-center py-5 text-muted">
                <p>No questions selected for this quiz.</p>
             </div>
          )} */}

        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-2 bg-white">
        <button className="btn btn-secondary w-100 fw-bold" onClick={onHide}>Close Preview</button>
      </Modal.Footer>
    </Modal>
  );
};

export default QuizPreviewModal;